import { render, staticRenderFns } from "./frameWihtHome.vue?vue&type=template&id=514b3240&scoped=true&"
import script from "./frameWihtHome.vue?vue&type=script&lang=js&"
export * from "./frameWihtHome.vue?vue&type=script&lang=js&"
import style0 from "./frameWihtHome.vue?vue&type=style&index=0&id=514b3240&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514b3240",
  null
  
)

export default component.exports